/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIRequestFile } from './APIRequestFile';
import {
    APIRequestFileFromJSON,
    APIRequestFileFromJSONTyped,
    APIRequestFileToJSON,
} from './APIRequestFile';

/**
 * 
 * @export
 * @interface APIPaginatedRequestFileList
 */
export interface APIPaginatedRequestFileList {
    /**
     * 
     * @type {number}
     * @memberof APIPaginatedRequestFileList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedRequestFileList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedRequestFileList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<APIRequestFile>}
     * @memberof APIPaginatedRequestFileList
     */
    results: Array<APIRequestFile>;
}

/**
 * Check if a given object implements the APIPaginatedRequestFileList interface.
 */
export function instanceOfAPIPaginatedRequestFileList(value: object): value is APIPaginatedRequestFileList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function APIPaginatedRequestFileListFromJSON(json: any): APIPaginatedRequestFileList {
    return APIPaginatedRequestFileListFromJSONTyped(json, false);
}

export function APIPaginatedRequestFileListFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPaginatedRequestFileList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(APIRequestFileFromJSON)),
    };
}

export function APIPaginatedRequestFileListToJSON(value?: APIPaginatedRequestFileList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(APIRequestFileToJSON)),
    };
}

